



export class McButton extends HTMLElement {

  constructor() {
    super()
    this.attachShadow({ mode: "open" })
    const templ = document.createElement("template")
    templ.innerHTML = `
<style>
button {
  border: none;
  background: linear-gradient(to right, hsl(var(--mc-overlay)), hsl(var(--mc-overlay) / .2));
  padding: .5rem;
  color: hsl(var(--mc-text));
  border-radius: 5px;
  box-shadow: 0 0 .1rem hsl(var(--mc-text) / .3);
  transition: all ease-in-out .15s;
}

button:hover {
  box-shadow: 0 0 .1rem hsl(var(--mc-text) / .3), 0 .1rem .3rem hsl(var(--mc-text) / .3) ;
}

button:focus {
  box-shadow: 0 0 .1rem hsl(var(--mc-text) / .3), 0 .1rem .3rem hsl(var(--mc-text) / .3) ;
  outline: none;
}

</style>

<button part="button">
  <slot></slot>
</button>
`
    this.shadowRoot.append(templ.content.cloneNode(true))
  }
}


if (!window.customElements.get("mc-button"))
  window.customElements.define("mc-button", McButton)
